(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('AddIndividualsDialogController', AddIndividualsDialogController);

    function AddIndividualsDialogController(logger, config, $uibModalInstance, $translate) {
        var vm = this;

        vm.identities = [];
        vm.isAdmin = config.settings.user.isAdmin;

        vm.cancel = cancel;
        vm.removeIdentity = removeIdentity;
        vm.identitySelected = identitySelected;
        vm.ok = ok;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function removeIdentity(idx) {
            vm.identities.splice(idx, 1);
        }

        function identitySelected(identity) {
            var existing = _.find(vm.identities, { idString: identity.idString });
            if (existing) return;
            vm.identities.push({ idString: identity.idString, name: identity.displayName });
        }

        function ok() {
            $uibModalInstance.close(vm.identities);
        }
    }
})();
